import { Award, Users, Clock, Shield } from "lucide-react";
export const features = [
  {
    icon: Award,
    title: "Award-Winning Care",
    description: "Recognized for excellence in patient care and medical innovation"
  },
  {
    icon: Users,
    title: "Expert Team",
    description: "Board-certified physicians and healthcare professionals"
  },
  {
    icon: Clock,
    title: "24/7 Emergency",
    description: "Round-the-clock emergency and critical care services"
  },
  {
    icon: Shield,
    title: "Patient Safety",
    description: "Highest standards of safety and quality assurance"
  }
];